import PropTypes from 'prop-types';
import React from 'react';
import StockOrb from './StockOrb';
import t from '@jetshop/intl';

const StockStatusIndicator = ({ status, text, className }) => {
  return (
    <p className={className}>
      <StockOrb status={status} />
      <span className="label-and-text">
        <span className="label">{t('Stock status')}: </span>
        <span className="stock-status-text">{text}</span>
      </span>
    </p>
  );
};

StockStatusIndicator.propTypes = {
  status: PropTypes.oneOf(['inStock', 'outOfStock', 'notifyWhenBack']),
  text: PropTypes.string
};

export default StockStatusIndicator;
